import React, { useState, useContext, useEffect, useRef } from 'react';
import { LiaUserEditSolid } from "react-icons/lia";
import { FaCircleCheck } from "react-icons/fa6";
// import { Images } from '../../../utils/Images'
import ImageCrop from '../../../components/Form/Picture'
import { useLocation } from 'react-router-dom'
import About from "../../../components/MyProfile/About"
import PremiumLock from "../../../components/MyProfile/PremiumLock"
import BasicLifeStyle from "../../../components/MyProfile/BasicLifeStyle"
import ContactDetails from "../../../components/MyProfile/ContactDetails"
import EducationCareer from "../../../components/MyProfile/EducationCareer"
import FamilyDetails from "../../../components/MyProfile/FamilyDetails"
import LocationOfGroom from "../../../components/MyProfile/LocationOfGroom"
import PersonalInterest from "../../../components/MyProfile/PersonalInterest"
import ReligiousBackground from "../../../components/MyProfile/ReligiousBackground"
// partner preference
import BasicInformations from "../../../components/MyProfile/PartnerPreference/BasicInformations"
import LocationDetails from "../../../components/MyProfile/PartnerPreference/LocationDetails"
import PartnerEducationCareer from "../../../components/MyProfile/PartnerPreference/PartnerEducationCareer"
import Others from "../../../components/MyProfile/PartnerPreference/Others"
// import QuickItems from '../../../components/MyBiye/QuickItems/Index'
import Loading from '../../../components/Loading/Index'
import { AgeCalculate, HeightCalculate } from '../../../utils/helpers'
import { UserContext } from '../../../utils/context/userContext'
import './style.scss'


const Index = () => {

    let { search } = useLocation();
    const [show, setShow] = useState(false)
    const { user } = useContext(UserContext)
    const contact = useRef(null)
    const parterpreference = useRef(null)

    // console.log("user", user);
    
    
    // useEffect(()=>{
    //     console.log(search);
        
    //     if (search.split('=')[1] === 'con') {
    //         contact.current.scrollIntoView({behavior: "smooth"})
    //     }
    //     else if (search.split('=')[1] === 'parpre') {
    //         parterpreference.current.scrollIntoView({behavior: "smooth"})
    //     }
    // },[search])

    useEffect(() => {
  const params = new URLSearchParams(search);
  const tab = params.get("tab");

  if (tab === "con") {
    contact.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  if (tab === "parpre") {
    parterpreference.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
}, [search]);


    if (!user) return <Loading />
    return (
        <div className="myprofile-container">
            <div className="container">
                <div className="row ">
                    <div className="col-12">
                        <div className="d-lg-flex">
                            {/* <QuickItems /> */}
                           
                            <div className="flex-fill main-section px-lg-4 pt-4 pt-lg-0 pb-4">
                                {/* Profile Header Card */}
                                <div className="card shadow-sm">

                                    {/* Cover */}
                                    <div
                                        style={{
                                            height: "120px",
                                            background: "linear-gradient(90deg,#33b39c,#9ad4c8)"
                                        }}
                                    ></div>

                                    <div className="card-body position-relative">

                                        <div className="row align-items-center">

                                            {/* Profile Image */}
                                            <div className="col-md-6 d-flex align-items-center">

                                                <div className="position-relative me-3">
                                                    <img src={user.profilePicture.clearImage} className="rounded border border-4 border-white"
                                                        style={{ width: "110px", marginTop: "-70px" }} alt="" />

                                                    <span className="position-absolute rounded-circle"
                                                     style={{
                                                            width: "14px",
                                                            height: "14px",
                                                            bottom: "5px",
                                                            right: "5px",
                                                            // border: "2px solid white"
                                                        }}
                                                        
                                                    ><FaCircleCheck size={14} className='text-success'/></span>
                                                </div>
                                                {/* 
                                                        style={{
                                                            width: "14px",
                                                            height: "14px",
                                                            bottom: "5px",
                                                            right: "5px",
                                                            border: "2px solid white"
                                                        }} */}

                                                <div>
                                                    <h4 className="mb-1">
                                                        {user.name}{" "}
                                                        {/* <FaCheckCircle color="#0d6efd" /> */}
                                                    </h4>

                                                    <div className="text-muted">
                                                        ID-{user.profileId} | Active Now
                                                    </div>

                                                    <div className="primary-text">
                                                        {user.dob ? AgeCalculate(user.dob) : "Age"} & {user?.basicAndLifestyleInformation?.height
                                                         ? HeightCalculate(user.basicAndLifestyleInformation.height) : "Height not available"}, {" "}
                                                         {user?.basicAndLifestyleInformation?.materialStatus ? 
                                                    user.basicAndLifestyleInformation.materialStatus : "Material Status not available"}
                                                    </div>
                                                </div>

                                            </div>

                                            {/* Buttons */}
                                            <div className="col-md-6 text-md-end mt-3 mt-md-0">

                                                <button className="btn btn-light me-2" onClick={() => setShow(true)}>
                                                    <LiaUserEditSolid /> Edit Profile
                                                </button>

                                                {/* <button className="btn btn-success">
                                                    <FaShareAlt /> Share Profile
                                                </button> */}

                                            </div>

                                        </div>

                                    </div>

                                </div>

                                {/* Profile Completion */}
                                <div className="card shadow-sm my-4">
                                    <div className="card-body">

                                        <div className="d-flex justify-content-between mb-2">
                                            <strong>Profile Completion</strong>
                                            <span className="primary-text">{user.profileUpdateRange}% Complete</span>
                                        </div>

                                        <div className="progress">
                                            <div
                                                className="progress-bar"
                                                style={{ width: user.profileUpdateRange + "%" , background:'#0b8c97' }}
                                            ></div>
                                        </div>

                                        <small className="text-muted d-block mt-2">
                                            Add your education & professional details to reach 100% and get more matches.
                                        </small>

                                    </div>
                                </div>

                                {/* <div className="row pt-3 pb-5">
                                    <div className="col-12 col-md-4">
                                        <div className="profileImage">
                                            <img src={user.profilePicture.clearImage} className="rounded-circle img-fluid" alt="" />
                                            <button type="button" className="btn shadow rounded-circle" onClick={() => setShow(true)}>
                                                <Icon icon={edit2} size={18} />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-8 profileBasicInfo">
                                        <h5 className="">{user.name}</h5>
                                        <div className="pt-2 pb-5 ml-3" >
                                            <table >
                                                <tr>
                                                    <th>ID</th>
                                                    <td className="pl-md-5">:</td>
                                                    <td >{user.profileId}</td>
                                                </tr>
                                                <tr>
                                                    <th>Material Status</th>
                                                    <td className="pl-md-5">:</td>
                                                    <td>{user?.basicAndLifestyleInformation?.materialStatus ? 
                                                    user.basicAndLifestyleInformation.materialStatus : "N/A"}</td>
                                                </tr>
                                                <tr>
                                                    <th>Posted By</th>
                                                    <td className="pl-md-5">:</td>
                                                    <td>{user?.profileCreatedFor ? user?.profileCreatedFor : "Not Available"}</td>
                                                </tr>
                                                <tr>
                                                    <th>Mother Tongue</th>
                                                    <td className="pl-md-5">:</td>
                                                    <td>{user?.language.motherTongue ? user?.language.motherTongue : "Not Available"}</td>
                                                </tr>
                                                <tr>
                                                    <th>Age & Height</th>
                                                    <td className="pl-md-5">:</td>
                                                    <td>
                                                        {user.dob ? AgeCalculate(user.dob) : "Age"} & {user?.basicAndLifestyleInformation?.height
                                                         ? HeightCalculate(user.basicAndLifestyleInformation.height) : "Height not available"}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div className="progress shadow">
                                            <div className="progress-bar" role="progressbar" style={{ width: user.profileUpdateRange + "%" }} aria-valuenow="45" aria-valuemin="0" aria-valuemax="100">{user.profileUpdateRange}%</div>
                                        </div>
                                    </div>
                                </div> */}
                                <About />
                                <BasicLifeStyle profileId={user.profileId} name={user.name} />
                                <ReligiousBackground />
                                <FamilyDetails />
                                <EducationCareer />
                                <LocationOfGroom />
                                <PersonalInterest />
                                {/* <div ref={contact}>Contact Section</div>

                                <div ref={parterpreference}>
                                Partner Preference
                                </div> */}
                                {/* <div ref={parterpreference} id="parterpreference" name="parterpreference" 
                                className="shadow p-3 mb-3 mt-5 bg-body rounded">Partner Preference</div> */}
                                {/* {user?.profileType === "Free" ? 
                                <PremiumLock/> : 
                                <> */}
                                <BasicInformations />
                                <LocationDetails />
                                <PartnerEducationCareer />
                                <Others />
                                {/* <Scroll.Element id="contact" name="contact"> */}
                                <div ref={contact} id="contact" name="contact-div" className="shadow p-3 mb-3 mt-5 bg-body rounded">Contact Details</div>
                                {/* </Scroll.Element> */}
                                <ContactDetails />
                                {/* </>} */}
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {show ? <ImageCrop show={show} onHide={() => setShow(false)} /> : null}
        </div>
    );
};

export default Index;